<template>
<div>
  <div class="wistia_embed wistia_async_tl04grc75i">
    &nbsp;
  </div>

  <div
    id="six_dimensions"
    class="tbk-vid-embed"
  >
    <a
      id="health"
      class="embedded_video"
      href="#wistia_44vaqz4777?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="purpose"
      class="embedded_video"
      href="#wistia_o2sfm4k7lw?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="relationships"
      class="embedded_video"
      href="#wistia_bfi4bl4cew?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="community"
      class="embedded_video"
      href="#wistia_1a4khnxpdd?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="security"
      class="embedded_video"
      href="#wistia_ntu7fl4r9x?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="environment"
      class="embedded_video"
      href="#wistia_1sdq3jltb1?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('tl0', 30, this.showSelect)

    this.tbk.loadCrossTime('44v', 216, this.showSelect)
    this.tbk.loadCrossTime('o2s', 101, this.showSelect)
    this.tbk.loadCrossTime('bfi', 82, this.showSelect)
    this.tbk.loadCrossTime('1a4', 129, this.showSelect)
    this.tbk.loadCrossTime('ntu', 240, this.showSelect)
    this.tbk.loadCrossTime('1sd', 135, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '44v': this.tbk.autoPlay,
        o2s: this.tbk.autoPlay,
        bfi: this.tbk.autoPlay,
        '1a4': this.tbk.autoPlay,
        ntu: this.tbk.autoPlay,
        '1sd': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#six_dimensions
  display: none
  a
    text-decoration: none
#health
  position: absolute
  top: calc(100% * (90 / 360))
  left: calc(100% * (85 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (110 / 360))
#purpose
  position: absolute
  top: calc(100% * (205 / 360))
  left: calc(100% * (85 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (110 / 360))
#relationships
  position: absolute
  top: calc(100% * (90 / 360))
  left: calc(100% * (260 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (110 / 360))
#community
  position: absolute
  top: calc(100% * (205 / 360))
  left: calc(100% * (260 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (110 / 360))
#security
  position: absolute
  top: calc(100% * (90 / 360))
  left: calc(100% * (440 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (110 / 360))
#environment
  position: absolute
  top: calc(100% * (205 / 360))
  left: calc(100% * (440 / 640))
  width: calc(100% * (120 / 640))
  height: calc(100% * (110 / 360))
</style>
